<template>
  <div class="mx-auto mt-6">
    <div class="minHeightMainContent flex-col">
      <div v-if="!loading" class="w-3/4 md:w-1/2 lg:w-1/3">
        <UiSingleSelect
          v-model="sectionName"
          title="RENAME_FEATURE_TO"
          :options="FEATURES_NAME.SECTION"
          label="title"
          reduce="name"
          placeholder="CHANGE_SECTION_NAME"
          @change="renameSections"
          @deSelect="deSelectSection"
        />
      </div>
      <Loader v-else class="mt-28" :content="true" />
    </div>
  </div>
</template>

<script>
import Loader from '@components/BaseComponent/Loader.vue'
import FEATURES_NAME from '@/src/constants/feature-name-constants'
import { mapState, mapActions } from 'vuex'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
export default {
  components: {
    Loader,
    UiSingleSelect,
  },
  page: {
    title: 'System Settings | Section Settings',
    meta: [
      {
        name: 'description',
        content: 'Section Settings',
      },
    ],
  },
  data: function () {
    return {
      FEATURES_NAME,
      loading: false,
      sectionName: '',
    }
  },
  computed: {
    ...mapState('layout', ['currentCampusScope']),
  },
  watch: {
    currentCampusScope: {
      handler: function () {
        this.setSectionName()
      },
      deep: true,
    },
  },
  methods: {
    async renameSections(value) {
      const payload = {
        original_name: 'SECTIONS',
        custom_name: value ? value : 'SECTIONS',
      }
      try {
        await this.setFeatureRename(payload)
      } catch (error) {
        this.sectionName = ''
      }
    },
    deSelectSection() {
      let payload = { original_name: 'SECTIONS', custom_name: 'SECTIONS' }
      this.setFeatureRename(payload)
    },
    async setSectionName() {
      const isUpper = !this.currentCampusScope
      const response = await this.fetchFeatureRename(isUpper)
      const features = response?.renamed_features || []
      const setSectionName = features.find(
        (item) => item.original_name === 'SECTIONS' && item.is_upper_level === isUpper,
      )
      if (setSectionName) this.sectionName = setSectionName.custom_name
    },
    ...mapActions('featureNaming', ['setFeatureRename', 'fetchFeatureRename']),
  },
}
</script>
